import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceDetectionService {
  isTV(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    const isTvAgent =
      userAgent.includes('smarttv') ||
      userAgent.includes('smart-tv') ||
      userAgent.includes('hbbtv') ||
      userAgent.includes('tizen') ||
      userAgent.includes('webos') ||
      userAgent.includes('viera') ||
      userAgent.includes('bravia') ||
      userAgent.includes('appletv') ||
      userAgent.includes('googletv') ||
      userAgent.includes('firetv') ||
      userAgent.includes('roku');

    const width = window.screen.width;
    const height = window.screen.height;
    const isHugeDisplay = width >= 2000 && height >= 1080;

    return isTvAgent || isHugeDisplay;
  }
}
